module.exports = __webpack_public_path__ + "img/add_to_cart.d11196fd.svg";